<template>
    <div v-click-outside="clickOutsideConfig" v-if="getItem('showModal')" class="ninedots-box" ref="ninedotsBox">
      <div class="ninedots-search">
        <div class="search-bar">
          <input type="text" class="search-input" placeholder="Find products" />
          <img class="search-icon" :src="require('../../img/ninedots-search-icon.svg')" alt="Search" />
        </div>
      </div>
      <div class="ninedots-grid">
        <div
          v-for="icon in iconsWithLockStatus"
          :key="icon.title"
          class="ninedots-icon"
          @click="handleIconClick(icon)"
        >
          <div class="icon-wrapper">
            <img class="icon" :src="require(`../../img/${icon.src}`)" />
            <div v-if="icon.title === 'ninedots_title_lawlex' && getItem('lawlexLoading')" class="spinner-overlay"></div>
          </div>
          <span class="title-wrapper">
            <img v-if="icon.lock" class="lock" :src="require('../../img/ninedot-lock.svg')" />
            <span class="icon-title">{{ $t(icon.title) }}</span>
          </span>
        </div>
      </div>
    </div>
  </template>

  <script>
  import { createNamespacedHelpers } from 'vuex';
  import vClickOutside from 'v-click-outside';
  import { apiRedirectToLawlex, apiRedirectToEurlex } from "./api";
  import i18n from "@/plugins/i18n";
  import {LAWLEX_STATUS_TRUE, LAWLEX_API_NOT_CALLED} from "./constant";

  const { mapActions: nineDotsMapActions, mapGetters: nineDotsMapGetters } = createNamespacedHelpers('ninedots');
  const profile = window.user_profile ? JSON.parse(Buffer.from(window.user_profile, "base64")) : {};
  const env = window.env ? (atob(window.env) === 'production' ? 'www.' : atob(window.env) + '.') : '';

  export default {
    name: "NineDots",
    directives: {
      clickOutside: vClickOutside.directive
    },
    data() {
      return {
        clickOutsideConfig: {
          handler: this.clickOutSideHandler,
          middleware: this.clickOutSideMiddleware,
          events: ['click']
        },
        icons: [
          { src: 'icon-standards.svg', title: 'ninedots_title_standards', enable_url: '/management/search/standards', disable_url:'https://'+env+'intertekinform.com/en-au/standards-management/' },
          { src: 'icon-metals.svg', title: 'ninedots_title_metals' , enable_url: '/management/search/metals', disable_url:'https://'+env+'intertekinform.com/en-au/standards-management/features/metals-infobase/'},
          { src: 'icon-materials.svg', title: 'ninedots_title_materials' , enable_url: '/management/search/materials', disable_url:'https://'+env+'intertekinform.com/en-au/standards-management/features/materials-infobase/'},
          { src: 'icon-ncc.svg', title: 'ninedots_title_ncc' , enable_url: '/management/ncc/index', disable_url:'https://'+env+'intertekinform.com/en-au/standards-management/ncc-on-i2i/'},
          { src: 'icon-lawlex.svg', title: 'ninedots_title_lawlex' , enable_url: '', disable_url:'https://'+env+'intertekinform.com/en-au/regulatory-management/'},
          { src: 'icon-eurlex.svg', title: 'ninedots_title_eurlex' , enable_url: '', disable_url:'https://'+env+'intertekinform.com/en-gb/regulatory-management/'},
          // This icons are kept commented for future use
          // { src: 'icon-compliance-hub.svg', title: 'ninedots_title_compliance_hub' , enable_url: '', disable_url:''},
          // { src: 'icon-logicom.svg', title: 'ninedots_title_logicom' , enable_url: '', disable_url:''},
          // { src: 'icon-training.svg', title: 'ninedots_title_training' , enable_url: '', disable_url:''}
        ],
      };
    },
    mounted() {
      window.showModal = false;
    },
    computed: {
      ...nineDotsMapGetters(['getItem']),
      iconsWithLockStatus() {
        const availableOptions = profile.availableSubscriptionOptions;

        return this.icons.map(icon => {
          const optionKey = icon.title.replace('ninedots_title_', '').toLowerCase();

          if (icon.title === 'ninedots_title_lawlex') {
            return { ...icon, lock: !this.getItem('showLawlexLockIcon') };
          }

          if (icon.title === 'ninedots_title_eurlex') {
            return { ...icon, lock: availableOptions['lawlexeu'] !== 1 };
          }


          return {
            ...icon,
            lock: availableOptions[optionKey] !== 1
          };
        });
      },

      showModalComputed() {
        return this.getItem('showModal');
      }
    },
    methods: {
      ...nineDotsMapActions(['setItem', 'initNineDots', 'closeNineDots', 'loadLawlexApi', 'addToIpdLog']),
      closeNineDotsWindow() {
        this.closeNineDots();
        window.showModal = false;
        document.getElementById('nine-dot-menu').classList.remove('modal-open');
      },
      clickOutSideHandler() {
        this.closeNineDotsWindow();
        document.getElementById('nine-dot-menu').classList.remove('modal-open');
      },
      clickOutSideMiddleware(event) {
        const nineDotMenu = document.getElementById('nine-dot-menu');

        const isNineDotMenuClick = nineDotMenu && nineDotMenu.contains(event.target);
        const isInsideModal = this.$refs.ninedotsBox && this.$refs.ninedotsBox.contains(event.target);

        if (isNineDotMenuClick || isInsideModal) {
          return false;
        }

        return true;
      },
      async handleIconClick(icon) {
          if (icon.title === 'ninedots_title_lawlex' && !icon.lock) {
            return await apiRedirectToLawlex();
          }
        if (icon.title === 'ninedots_title_eurlex' && !icon.lock) {
          return await apiRedirectToEurlex();
        }
        const url = icon.lock ? icon.disable_url : icon.enable_url;
          await this.addToIpdLog({ moduleName: 'NineDots - ' + i18n.t(icon.title), linkClicked: url });
          if (url) {
              window.open(url, icon.lock ? '_blank' : '_self');
          }
      },
      async onModalOpened() {
        if(this.getItem('lawlexApiLoaded') == LAWLEX_API_NOT_CALLED) {
          await this.loadLawlexApi();
        } else if(this.getItem('lawlexApiLoaded') == LAWLEX_STATUS_TRUE) {
          this.setItem({'field':'showLawlexLockIcon','value':true});
        } else {
          this.setItem({'field':'showLawlexLockIcon','value':false});
        }
      }
    },
    watch: {
      showModalComputed(newVal) {
        if (newVal) {
          this.onModalOpened();
        }
      }
    }
  };
  </script>

  <style scoped lang="scss">
  @import "nine-dots";
  </style>
